module.exports = __webpack_public_path__ + "static/media/service-list-3.4146b6f3.jpg";